import config from 'src/config';
import type { EvaluateFeatureFlagParams, EvaluateFeatureFlagResponse } from 'src/shared/types/cms/featureFlags';

import apiService from './api-service';

const FALLBACK_RESPONSE: EvaluateFeatureFlagResponse = { enabled: false };

export class FeatureFlagService {
    public async evaluateFeatureFlag(params: EvaluateFeatureFlagParams): Promise<EvaluateFeatureFlagResponse> {
        const { featureId, customerId } = params;

        try {
            const searchParams = new URLSearchParams();
            searchParams.set('featureId', featureId);
            if (customerId) {
                searchParams.set('customerId', customerId);
            }

            const response = (await apiService.fetch(`${config.cmsApiUrl}/feature-flags/evaluate?${searchParams.toString()}`, {
                ignoreErrors: true,
            })) as EvaluateFeatureFlagResponse | null;

            if (response !== null && typeof response.enabled === 'boolean') {
                return { enabled: response.enabled };
            }
            return FALLBACK_RESPONSE;
        } catch (error) {
            console.error('Failed to evaluate feature flag', error);
            return FALLBACK_RESPONSE;
        }
    }
}

export default new FeatureFlagService();
